<template>
  <div class="d-flex flex-wrap align-items-center">
    <div class="mr-auto">
      <p class="text-uppercase text-dark font-weight-bold mb-1">
        {{ title }}
      </p>
      <p class="text-gray-5 mb-0">
        {{ subTitle }}
      </p>
    </div>
    <p class="text-primary font-weight-bold font-size-24 mb-0">
      {{ value }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'KitGeneral2v1',
  props: {
    title: String,
    value: String,
    subTitle: String,
  },
}
</script>
